/*
 * @Author: Tom Voorneveld <tom>
 * @Date:   2017-12-09T12:53:03+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe - Bootstrap Vue component for Lazy loading images in PWA's
 * @Last modified by:   tom
 * @Last modified time: 2018-02-08T21:15:43+01:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved

 Example:
   <lzimg
     src="https://lorempixel.com/600/400/cats/1/"
     alt="[thisisanimage]"
     no-lazy
     center
     thumbnail
     zoom-modal
     modal-header="Detailed picture"
     fluid-grow
     width="600"
     height="400"
     class="my-5" />

 Dont forget to include in your main.js:
  import './assets/lib/_lazy-image.js'

Props:
  thumbnail: show thumbnail border
  zoom-modal: allow to click to zoom fullscreen in a modal
  modal-header: title in the modal header, if no header content is set, hide completely

*/

import Vue from 'vue'

Vue.component('lzimg', {
  name: 'LzImg',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    noLazy: { type: Boolean, default: false },
    fluid: { type: Boolean, default: false },
    fluidGrow: { type: Boolean, default: false },
    thumbnail: { type: Boolean, default: false },
    zoomModal: { type: Boolean, default: false },
    modalHeader: { type: String, default: '' },
    width: { type: String, default: '100' },
    height: { type: String, default: '100' },
    blanksrc: { type: String, default: '' }
  },
  computed: {
    id: function () {
      return this._uid
    },
    fileName: function () {
      const pathArr = this.src.split('/')
      return pathArr.pop()
    },
    altImg: function () {
      return this.alt || ('[' + this.fileName + ']')
    }
  },
  methods: {
    hideModal () {
      this.$refs.imgmodalref.hide()
    },
    isImgCached: function () {
      /* global Image */
      var image = new Image()
      image.src = this.src
      if (image.complete || this.noLazy) {
        // we have the image, so we can use normal <img> code to prevent undesired lazy side effects
        return true
      } else {
        // use <b-img-lazy
        console.log(this.src + ' not in cache >> load async')
        return false
      }
    }
  },
  template: `
    <div v-if="zoomModal">
      <b-img
        v-if="isImgCached()"
        :src="src"
        :fluid="fluid"
        :fluid-grow="fluidGrow"
        :thumbnail="thumbnail"
        :width="width"
        :height="height"
        :alt="altImg"
        :style="{ cursor: 'pointer' }"
        v-b-modal="id + '_modal'"/>

      <b-img-lazy
        v-else
        throttle=50
        offset=100
        :src="src"
        :blank-src="blanksrc"
        :blank-width="width"
        :blank-height="height"
        :fluid="fluid"
        :fluid-grow="fluidGrow"
        :thumbnail="thumbnail"
        :width="width"
        :height="height"
        :alt="altImg"
        :style="{ cursor: 'pointer' }"
        v-b-modal="id + '_modal'"/>

      <b-modal
        :id="id + '_modal'"
        ref="imgmodalref"
        class="fullscreenimgmodal"
        size="lg"
        centered
        :title="modalHeader"
        :hide-header="!modalHeader"
        header-bg-variant="secondary"
        header-text-variant="white"
        body-bg-variant="white"
        hide-footer>
        <b-img
          :src="src"
          fluid-grow
          :alt="altImg"
          @click="hideModal"/>
      </b-modal>
    </div>

    <div v-else>
      <b-img
        v-if="isImgCached()"
        :src="src"
        :fluid="fluid"
        :fluid-grow="fluidGrow"
        :thumbnail="thumbnail"
        :width="width"
        :height="height"
        :alt="altImg"/>

      <b-img-lazy
        v-else
        throttle=50
        offset=100
        :src="src"
        :blank-src="blanksrc"
        :blank-width="width"
        :blank-height="height"
        :fluid="fluid"
        :fluid-grow="fluidGrow"
        :thumbnail="thumbnail"
        :width="width"
        :height="height"
        :alt="altImg"/>

    </div>

  `
})
